import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: '热门栏目',
    links: [
      { label: '今日热瓜', to: '/channel/regua' },
      { label: '下饭专区', to: '/channel/xiafan' },
      { label: '摸鱼段子', to: '/channel/moyu' },
      { label: '沙雕图鉴', to: '/channel/shadiaotujian' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '网站介绍', to: '/about' },
      { label: '内容原则', to: '/about#principles' },
      { label: '用户口碑', to: '/about#reviews' },
      { label: '联系我们', to: '/about#contact' },
    ],
  },
  {
    title: '常用入口',
    links: [
      { label: '迷惑行为', to: '/channel/mihuo' },
      { label: '夜市闲谈', to: '/channel/yezhu' },
      { label: '常见问题', to: '/#faq' },
      { label: '我要投稿', to: '/about#contact' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
                <i className="ri-water-flash-fill w-6 h-6 flex items-center justify-center" />
              </span>
              <span className="font-heading text-xl tracking-wide text-background-50">
                糖心吃瓜网
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              饭点不知道配什么？这里集合了下饭、解闷、摸鱼必备笑料，随手点开一条就能喷饭，专治无聊空虚。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['今日上新 128 条', '每日 20:00 更新', '支持手机浏览'].map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-200"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <nav key={column.title} className="lg:col-span-2">
              <h4 className="font-heading text-base text-background-50">{column.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-primary-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-heading text-base text-background-50">联系</h4>
            <a
              href="mailto:hello@tangxin-chigua.example.com"
              className="mt-4 block break-all text-sm text-background-300 transition-colors hover:text-primary-300"
            >
              hello@tangxin-chigua.example.com
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 糖心吃瓜网 · 快乐内容分享平台</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容仅供娱乐，请理性吃瓜</span>
            <Link to="/about#principles" className="transition-colors hover:text-primary-300">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}